let disputeResponseOptions = [
  {
    label: "Toutes",
    value: "ALL",
  },
  {
    label: "Réponse acceptée",
    value: "ANSWER_ACCEPTED",
  },
  {
    label: "Avertissement",
    value: "WARNING",
  },
  {
    label: "Mise à pied",
    value: "SUSPENSION",
  },
  {
    label: "Licenciement",
    value: "DISMISSAL",
  },
  {
    label: "Détérioration de materiel",
    value: "EQUIPMENT_DAMAGE",
  },
];

export default disputeResponseOptions;
